import SafeHtml from '~/vue_shared/directives/safe_html';
import MarkdownFieldView from '../../vue_shared/components/markdown/field_view.vue?vue3';
export default {
    name: 'SnippetDescriptionView',
    components: {
        MarkdownFieldView
    },
    directives: {
        SafeHtml
    },
    props: {
        description: {
            type: String,
            required: false,
            default: ''
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'gl-emoji',
            'copy-code'
        ]
    }
};
